var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 494,
    height: 194,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 494 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15167_31926)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 494,
    height: 194,
    rx: 16,
    fill: "#F3F2F1"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_15167_31926)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 454,
    height: 154,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 65,
    width: 330,
    height: 30,
    rx: 10,
    fill: "#DEECF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 40,
    width: 100,
    height: 15,
    rx: 7.5,
    fill: "#DEECF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435,
    y: 40,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#DFEAFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 118,
    width: 100,
    height: 32,
    rx: 10,
    stroke: "#0078D4",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 118,
    width: 100,
    height: 32,
    rx: 10,
    fill: "#DEECF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.858 150C298.619 150 300.858 147.761 300.858 145C300.858 142.239 298.619 140 295.858 140C293.096 140 290.858 142.239 290.858 145C290.858 147.761 293.096 150 295.858 150Z",
    fill: "#DFEAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.765 166.37C298.965 166.37 298.218 166.37 297.538 166.327C296.7 166.27 295.894 165.984 295.209 165.499C294.524 165.014 293.985 164.349 293.654 163.578L289.435 155.24C289.125 154.88 288.971 154.412 289.005 153.938C289.039 153.464 289.259 153.023 289.617 152.711C289.91 152.475 290.275 152.349 290.652 152.352C290.928 152.36 291.2 152.428 291.448 152.551C291.696 152.675 291.915 152.85 292.089 153.066L294.005 155.681L294.034 155.715V145.78C294.034 145.287 294.229 144.814 294.578 144.466C294.926 144.117 295.399 143.922 295.892 143.922C296.385 143.922 296.858 144.117 297.206 144.466C297.555 144.814 297.751 145.287 297.751 145.78V152.28C297.729 152.041 297.757 151.8 297.834 151.572C297.911 151.345 298.034 151.136 298.196 150.958C298.358 150.781 298.555 150.639 298.775 150.542C298.995 150.446 299.232 150.396 299.473 150.396C299.713 150.396 299.95 150.446 300.17 150.542C300.39 150.639 300.587 150.781 300.749 150.958C300.911 151.136 301.034 151.345 301.111 151.572C301.188 151.8 301.216 152.041 301.195 152.28V153.635C301.173 153.396 301.201 153.155 301.278 152.927C301.355 152.7 301.478 152.491 301.64 152.313C301.802 152.136 301.999 151.994 302.219 151.897C302.439 151.801 302.676 151.751 302.917 151.751C303.157 151.751 303.394 151.801 303.614 151.897C303.834 151.994 304.031 152.136 304.193 152.313C304.355 152.491 304.478 152.7 304.555 152.927C304.632 153.155 304.66 153.396 304.639 153.635V154.679C304.617 154.44 304.645 154.199 304.722 153.971C304.799 153.744 304.922 153.535 305.084 153.357C305.246 153.18 305.443 153.038 305.663 152.941C305.883 152.845 306.12 152.795 306.361 152.795C306.601 152.795 306.838 152.845 307.058 152.941C307.278 153.038 307.475 153.18 307.637 153.357C307.799 153.535 307.922 153.744 307.999 153.971C308.076 154.199 308.104 154.44 308.083 154.679V161.016C308.049 162.965 307.168 166.251 304.069 166.251C303.844 166.261 301.938 166.371 299.769 166.371L299.765 166.37Z",
    fill: "#0078D4",
    stroke: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_15167_31926",
    x: 5.6,
    y: 12,
    width: 482.8,
    height: 182.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15167_31926"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_15167_31926",
    result: "effect2_dropShadow_15167_31926"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_15167_31926",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15167_31926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 494,
    height: 194,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.0c4b43196398ff9d38c5b36b40c87ab5.svg";
export { ForwardRef as ReactComponent };